// extracted by mini-css-extract-plugin
export default {"loading":"PageLoading_loading__jHDyR","loadingShrink":"PageLoading_loadingShrink__p-OkO"};